import React, {useEffect, useMemo, useState} from 'react';
import useEodClosing from "../../api/EODClosing";
import TableSelectV2 from "../TableSelectV2";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faArrowDown, faGreaterThan} from "@fortawesome/free-solid-svg-icons";
import {useRowSelect, useTable} from "react-table";
import {Checkbox} from "../Checkbox";
import TableSkeleton from "../skeletons/TableSkeleton";
import Pagination from "../Pagination";
import CloseBalance from "./CloseBalance";
import {formatAccountRev} from "../../features/ValueFormater";
import CurrentBalance from "./CurrentBalance";
import UtcToLocal from "../UtcToLocal";
import SalesTransactionsAPI from "../../api/salesTransactions";
import {useDispatch, useSelector} from "react-redux";
import {setFlag} from "../../features/responseSlice";

function TrxTable({activeRowIndex, setActiveRowIndex, setVisible}) {
    const [totalNbPage, setTotalNbPage] = useState(0);
    const [selectedPage, setSelectedPage] = useState(1);
    const [searchQuery, setSearchQuery] = useState("");


    const {
        GetEODClosingTransactions,
        closingTransactions,
        transactionsLoading,
        totalNbOfPage
    } = useEodClosing();

    const options = {
        weekday: 'short',
        day: 'numeric',
        month: 'short',
        year: 'numeric'
    };

    const data = useMemo(() => closingTransactions || [], [closingTransactions]);
    const columns = useMemo(
        () => [
            {
                Header: "Transaction N",
                accessor: "Transaction",
            },
            {
                Header: "",
                accessor: "details",
                Cell: ({row}) => {
                    return <button className="showmore" onClick={() => {
                        setActiveRowIndex(row.index)
                    }}><FontAwesomeIcon icon={faArrowDown}/></button>
                },
            },
            {
                Header: "Report Name",
                accessor: "ReportName",
            },
            {
                Header: "From Date",
                accessor: "FromDate",
                Cell: ({value}) => {
                    return value &&
                        <UtcToLocal utcTimestamp={value} options={options} />
                }
            },
            {
                Header: "To Date",
                accessor: "ToDate",
                Cell: ({value}) => {
                    return value &&
                     <UtcToLocal utcTimestamp={value} options={options} />
                }
            },
            {
                Header: "N Transactions",
                accessor: "NumTransactions",
                Cell: ({value}) => {
                    return <b>{value}</b>
                }
            },
            {
                Header: "Total Amount",
                accessor: "TotalAmount",
                Cell: ({value, row}) => {
                    return <b>{formatAccountRev(value, row.original.CurrencyID)}</b>
                }
            },
            {
                Header: "Discounted Amount",
                accessor: "DiscountedAmount",
                Cell: ({value, row}) => {
                    return <b>{formatAccountRev(value, row.original.CurrencyID)}</b>
                }
            },
            {
                Header: "Currency",
                accessor: "CurrencyID",
                Cell: ({value}) => {
                    if (value === 1) return <b>USD</b> ;
                    return <b>LBP</b>;
                }
            },
            {
                Header: "",
                accessor: "AS",
                Cell: () => {
                    return <button onClick={() => {
                        setActiveRowIndex(-1)
                    }}><FontAwesomeIcon icon={faGreaterThan}/></button>;
                },
            }
        ],
        [closingTransactions]
    );

    const {getTableProps, getTableBodyProps, headerGroups, rows, prepareRow, selectedFlatRows} = useTable({
            columns,
            data
        }, useRowSelect,
        (hooks) => {
            hooks.visibleColumns.push((columns) => {
                return [
                    {
                        id: 'selection',
                        Header: ({getToggleAllRowsSelectedProps}) => (
                            <Checkbox {...getToggleAllRowsSelectedProps()} />
                        ),
                        Cell: ({row}) => (
                            <Checkbox {...row.getToggleRowSelectedProps()} />
                        )
                    },
                    ...columns,
                ]
            })
        });

    const filteredRows = rows.filter((row) => {
        return Object.values(row.original).some((cellValue) => {
            return cellValue.toString().toLowerCase().includes(searchQuery.toLowerCase());
        });
    });


    useEffect(() => {
        GetEODClosingTransactions(1);
    }, []);
    
    useEffect(()=>{
        setTotalNbPage(totalNbOfPage);
    }, [totalNbOfPage]);

    const {
        GetAvailableSalesAndBalance,
        availableBalances,
        balancesLoading
    } = SalesTransactionsAPI();

    const {flag} = useSelector((state) => state.transferResponse);
    const dispatch = useDispatch();

    useEffect(() => {
        GetAvailableSalesAndBalance();
        if (flag===0||flag===1){
            dispatch(setFlag(null));
        }
    }, [flag]);


    return (
        <>
            <CurrentBalance availableBalances={availableBalances} balancesLoading={balancesLoading}/>
            <CloseBalance availableBalances={availableBalances}/>

            <div className="row">
                {
                    transactionsLoading ? (
                        <TableSkeleton/>
                    ) : (
                        <TableSelectV2
                            headerGroups={headerGroups}
                            page={filteredRows}
                            prepareRow={prepareRow}
                            getTableProps={getTableProps}
                            getTableBodyProps={getTableBodyProps}
                            activeRowIndex={activeRowIndex}
                            setVisible={setVisible}
                            setActiveRowIndex={setActiveRowIndex}
                        />
                    )
                }

            </div>

            <Pagination
                getData={GetEODClosingTransactions}
                totalNbPage={totalNbPage}
                method="eodClosing"
                selectedPage={selectedPage}
                setSelectedPage={setSelectedPage}
            />
        </>
    );
}

export default TrxTable;